@if (alertDetalheFatura === true) {
  <div class="alert-fatura">
    <div class="acoes my-4">
      <button
        class="btn-icon p-0 border-0 bg-transparent"
        (click)="fecharModalFatura()"
        aria-label="Fechar modal de fatura">
        <i class="fa fa-arrow-left c-secondary" aria-hidden="true"></i>
      </button>
      <button
        class="btn-icon p-0 border-0 bg-transparent"
        (click)="onPrint()"
        aria-label="Imprimir">
        <i class="fa fa-print c-secondary" aria-hidden="true"></i>
      </button>
    </div>
    <div class="documento printMe" id="content">
      @if (dadosFatura === null) {
        <div class="pt-5">
          <div class="text-center">
            <output class="spinner-border c-primary">
              <span class="visually-hidden">Consultando detalhes da fatura ...</span>
            </output>
          </div>
          <p class="legenda-spinner">Consultando detalhes da fatura ...</p>
        </div>
      }
    </div>
  </div>
}